import { Button, Input } from "@ttc3k/trekker";
import { Minus, Plus } from "iconoir-react";
import { useEffect, useState } from "react";
import { Flex } from "styled-system/jsx";

type NumericStepperProps = {
  value?: number;
  onChange?: (value: number) => void;
  max?: number;
  min?: number;
  disabled?: boolean;
};

export const NumericStepper = ({
  value = 0,
  onChange,
  max,
  min,
  disabled = false,
}: NumericStepperProps) => {
  const [num, setNum] = useState(value);

  useEffect(() => {
    setNum(value);
  }, [value]);

  const handleChange = (val: number) => {
    if (disabled) return;
    if (val < 0) return;
    if (max != null && val > max) return;
    if (min != null && val < min) return;
    setNum(val);
    onChange?.(val);
  };

  return (
    <Flex gap={"100"} alignItems={"center"} opacity={disabled && num === 0 ? 0.4 : 1}>
      <Button
        Icon={Minus}
        size={"sm"}
        mode={"light"}
        onClick={() => handleChange(num - 1)}
        disabled={disabled || num === 0 || (min != null && num <= min)}
        type="button"
      />
      <Input
        value={num}
        onChange={e => handleChange(Number(e.target.value))}
        type="number"
        disabled={disabled}
        appearance={"textfield"}
        maxW={"26px"}
        width={"min-content"}
        px={"25"}
        textAlign={"center"}
        border={"none"}
        _hover={{
          _enabled: {
            boxShadow: "unset",
          },
        }}
        css={{
          "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
            appearance: "none",
            WebkitAppearance: "none",
          },
        }}
      />
      <Button
        Icon={Plus}
        size={"sm"}
        mode={"light"}
        onClick={() => handleChange(num + 1)}
        disabled={disabled || (max != null && num >= max)}
        type="button"
      />
    </Flex>
  );
};
